import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAppDispatch } from "@application/store/useStore";
import { verifyUniqueLinkAsync } from "@application/features/Event/EventThunk";
import { Box } from "@mui/material";
import { clearLinkVerification } from "@application/features/Event/EventSlice";
import { persistor, setPersistKey } from "@application/store";
export const MagicLinkValidator = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const drawerParam = searchParams.get("drawer");
    const userType = searchParams.get("userType") ?? "";
    useEffect(() => {
        persistor.purge();
        if (id) {
            setPersistKey(id);
            dispatch(clearLinkVerification());
            dispatch(verifyUniqueLinkAsync({ id, userType }))
                .unwrap()
                .then((response) => {
                if (response.isSuccess) {
                    const path = response.data?.navigationUrlPath
                        ? `/${response.data.navigationUrlPath}`
                        : "/event";
                    const drawerQuery = drawerParam ? `?drawer=${drawerParam}` : "";
                    navigate(`${path}${drawerQuery}`, { replace: true });
                }
                else {
                    navigate(response.data?.invalidLinkNavigationUrl, {
                        replace: true,
                    });
                }
            })
                .catch(() => {
                navigate("/invalid-link", { replace: true });
            });
        }
    }, [id, dispatch, navigate, persistor]);
    return (_jsx(Box, { sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            gap: 2,
        } }));
};
